export const SET_ORDERS                   = 'SET_ORDERS';
export const ORDERS_LOADING               = 'ORDERS_LOADING';
export const ORDERS_ERROR                 = 'ORDERS_ERROR';
export const CLEAR_ORDERS                 = 'CLEAR_ORDERS';
export const CLEAR_ORDERS_ERROR           = 'CLEAR_ORDERS_ERROR';
export const UPDATE_ORDER                 = 'UPDATE_ORDER';